import { Stack } from '@mui/material'

import { memo } from 'react'
import Text from './Text'

const DisplayValue = ({ title, desc }) => {
  return (
    <Stack
      sx={{
        color: 'var(--layout-nav-text-primary-color)',
        bgcolor: 'background.neutral',
        borderRadius: 2,
        p: 2
      }}
      spacing={1}
    >
      <Text
        variant='body1'
        label={title}
        sx={{ fontSize: 50, fontWeight: 800, lineHeight: 1 }}
      />
      {desc && <Text variant='body1' label={desc} fontWeight={500} />}
    </Stack>
  )
}

export default memo(DisplayValue)
